<ion-app>
  <app-wait></app-wait>

  <app-slide-menu />
  <ion-router-outlet id="main-content"></ion-router-outlet>
  <app-notification-toast />
  <app-a2hs-hint />
</ion-app>
